// Globals
import { CloudUploadOutlined } from '@ant-design/icons';
import { Attachments } from '@ant-design/x';
import { Button, UploadFile } from 'antd';
import { useState } from 'react';

// Modules
import { SUPPORTED_FILE_EXTS, useUploadFile } from '@/modules/FileUploader';

// Components
import { StyledSender } from './SenderContainerStyles';

type TChatContainerWrapperProps = {
  canUpload?: boolean;
  onSend: (message: string) => void;
};

export const SenderContainer = ({ onSend, canUpload }: TChatContainerWrapperProps) => {
  const [value, setValue] = useState('');
  const { isLoading, uploadFile } = useUploadFile();

  const handleFileSend = async ({ file }: { file: UploadFile }) => {
    const parsedResponse = await uploadFile(file as unknown as File);
    if (!parsedResponse?.file_url) return;
    onSend(`<a href="${parsedResponse.file_url}" target="_blank" rel="noopener noreferrer">${file.name}</a>`);
  };

  const handleSend = (value: string) => {
    const message = value.trim();
    if (!message) return;
    onSend(message);
    setValue('');
  };

  return (
    <StyledSender
      prefix={canUpload && (
        <Attachments
          beforeUpload={() => false}
          onChange={handleFileSend}
          disabled={isLoading}
          accept={SUPPORTED_FILE_EXTS.join(',')}
        >
          <Button icon={<CloudUploadOutlined />} loading={isLoading} />
        </Attachments>
      )}
      onSubmit={handleSend}
      value={value}
      onChange={setValue}
      loading={isLoading}
      placeholder="Напишіть повідомлення"
    />
  );
};
